const companyPlanTypes = {
  getCompanyPlanTypeBullets(id) {
    switch (id) {
      case this.$enums.companyPlanTypes.LITE:
        return [
          "Culture tracking survey",
          "Heatmap & analytics",
          "Anonymous feedback",
          "Admin dashboard",
          "Expert question library",
          "Custom question builder",
          "Mission & values builder",
          "Employee management",
          "Integrated Help Center",
          "Single sign-on (SSO)"
        ].map(x => ({ value: x, icon: "check" }));
      case this.$enums.companyPlanTypes.ENGAGEMENT:
        return [
          "Org chart",
          "Overall score",
          "Integrated business metrics",
          "Advanced reporting",
          "360 feedback",
          "Recognition",
          "Custom surveys",
          "Department reporting",
          "Manager dashboard"
        ]
          .map(x => ({ value: x, icon: "check" }))
          .concat([
            { value: "Employee rewards (coming soon)", icon: "redeem" }
          ]);
    }
    return [];
  },
  getCompanyPlanTypeAdditionalBullet(id) {
    switch (id) {
      case this.$enums.companyPlanTypes.ENGAGEMENT:
        return "Includes lite plan";
    }
    return "";
  },
  getCompanyPlanTypeSubTitle(id) {
    switch (id) {
      case this.$enums.companyPlanTypes.LITE:
        return "Empower your employees with the tools they need to share their unique insights";
      case this.$enums.companyPlanTypes.ENGAGEMENT:
        return "Organize your data and introduce culture building tools to drive growth";
    }
    return "";
  }
};

export default { methods: companyPlanTypes };
